export const searchQueryParamName = "szukaj";